import { forwardRef } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { setCancelDialog, LeaveUser } from "../../../app/slices/leaveUserSlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/** The rep cancelling one of their own pending requests. */
const LeaveCancelForm = () => {
  const _Cancel = useSelector((state) => state.leaveUser.cancel);
  const _SearchBody = useSelector((state) => state.leaveUser.searchBody);
  const dispatch = useDispatch();

  const { control, handleSubmit } = useForm({
    defaultValues: { comments: "" },
  });

  const onSubmit = (data) => {
    dispatch(
      LeaveUser.reject(_Cancel.data?.id, { comments: data.comments }, _SearchBody),
    );
  };

  return (
    <Dialog
      open={_Cancel.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth="xs"
      dir="rtl"
      onClose={() => dispatch(setCancelDialog())}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={1}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          الغاء طلب الاجازة
        </Typography>
        <Typography mb={3} variant="body2" color="text.secondary">
          {_Cancel.data?.start_date
            ? `من ${dayjs(_Cancel.data.start_date).format("YYYY-MM-DD")} الى ${
                _Cancel.data?.end_date
                  ? dayjs(_Cancel.data.end_date).format("YYYY-MM-DD")
                  : ""
              } - عدد الايام: ${_Cancel.data?.total_days ?? ""}`
            : null}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="comments"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="سبب الالغاء"
                    multiline
                    rows={3}
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="error">
                تاكيد الالغاء
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeaveCancelForm;
